<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
      default() {
        return null
      },
      validator: (value) =>
        ['down', 'up', 'stable'].includes(value.toLowerCase()),
    },
  },
}
</script>

<template>
  <span>
    <v-icon
      v-if="status === 'down'"
      :class="$style.historyDown"
      :title="$t('view_ranking.down')"
      >south</v-icon
    >
    <v-icon
      v-if="status === 'up'"
      :title="$t('view_ranking.up')"
      :class="$style.historyUp"
      >north</v-icon
    >
    <v-icon v-if="status === 'stable'" :title="$t('view_ranking.stable')"
      >horizontal_rule</v-icon
    >
  </span>
</template>

<style lang="scss" module>
@import '@design';

.historyicon {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.1rem !important;
}

.historyDown {
  composes: historyicon;
  color: red !important;
}

.historyUp {
  composes: historyicon;
  color: $color-success !important;
}
</style>
